<template>
  <div>
    <el-row>
      <el-input size="small" placeholder="请输入姓名搜索" v-model="searchUserName" style="width: 80% ">
        <el-button type="primary" slot="append" icon="el-icon-search" @click="searchName">搜索</el-button>
      </el-input>
      &nbsp;&nbsp;&nbsp;
      <el-button type="primary" v-show="isAdd"  size="small" @click="newStaffModal = true">新增</el-button>
    </el-row>
    <div style="height: 20px"></div>
    <datatable
      :highlight="true"
      :height="400"
      :loading="loading"
      :tableQuery="tableQuery"
      :tableData="tableData"
      @table-current-change="handleCurrentChange"
      @current-change="tableQuery.page=$event, search()"
      @size-change="tableQuery.size=$event, search()">
      <el-table-column label="选择" width="50">
        <template slot-scope="scope">
          <el-radio v-model="radio" :label="scope.row" @change="handleChange">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="姓名" prop="userName"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="性别" prop="userSex">
        <template slot-scope="scope">
          <span v-if="scope.row.userSex === 0">女</span>
          <span v-if="scope.row.userSex === 1">男</span>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="职位" prop="positionName"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="电话" prop="fixedPhone"></el-table-column>
    </datatable>
    <div style="text-align: right;margin-top: 20px">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button type="primary" size="small" @click="ok()">确定</el-button>
    </div>
    <el-dialog
      title="新增人员"
      width="20%"
      :visible.sync="newStaffModal"
      append-to-body>
      <el-form label-width="25%" :model="formData" :rules="rules" ref="ruleForm">
        <el-row>
          <el-form-item label="姓名:" prop="userName">
            <el-input v-model="formData.userName" size="small" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="性别:" prop="sex">
            <el-select size="small" style="width: 100%" v-model="formData.sex" placeholder="请选择">
              <el-option :value="1" label="男"></el-option>
              <el-option :value="0" label="女"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div style="text-align: center;margin-top: 20px">
        <el-button size="small" @click="newStaffModal = false">取消</el-button>
        <el-button type="primary" size="small" @click="createStaff('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { createStaff, selectUsers } from '@/api/resource'
export default {
  props: {
    queryType: {
      type: String,
      required: false,
      default: ''
    },
    isAdd: {
      type: Boolean,
      required: false,
      default: false
    },
    targetCity: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      cities: [],
      city: '',
      radio: '',
      searchUserName: '',
      newStaffModal: false,
      loading: true,
      tableData: {
        aaData: []
      },
      tableQuery: {
        page: 0,
        size: 5,
        filter: '',
        order: ''
      },
      val: {
        id: '0'
      },
      formData: {
        userName: '',
        sex: 0
      },
      rules: {
        userName: [
          {required: true, message: '请输入'}
        ],
        sex: [
          {required: true, message: '请选择', trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    this.search()
    this.keyupSubmit()
  },
  methods: {
    keyupSubmit () {
      document.onkeydown = e => {
        let _key = window.event.keyCode
        if (_key === 13) {
          this.searchName()
        }
      }
    },
    searchName () {
      this.tableQuery.page = 0
      if (this.targetCity !== '' && this.targetCity !== null) {
        this.city = this.targetCity.substring(0, 5)
      }
      this.tableQuery.filter = 'name=' + this.searchUserName + ';queryType=' + this.queryType + ';regionCode=' + this.city
      this.search()
    },
    search () {
      this.loading = true
      if (this.targetCity !== '' && this.targetCity !== null) {
        this.city = this.targetCity.substring(0, 5)
      }
      if (this.tableQuery.filter === '') {
        this.tableQuery.filter = 'name=' + this.searchUserName + ';queryType=' + this.queryType + ';regionCode=' + this.city
      }
      selectUsers(this.tableQuery).then(response => {
        this.tableData = response.data.data
        this.loading = false
      })
    },
    createStaff (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var validate = /^[\u4e00-\u9fa5a-zA-Z0-9_-]+$/
          if (!validate.test(this.formData.userName)) {
            return this.$notify.error({
              title: '错误',
              message: '请输入正确的姓名!'
            })
          }
          createStaff(this.formData).then(res => {
            this.formData.userName = ''
            this.formData.sex = 0
            this.searchName()
          })
          this.newStaffModal = false
        }
      })
    },
    handleChange (val) {
      this.val = val
    },
    handleCurrentChange (val) {
      this.radio = val
      this.val = val
    },
    cancel () {
      this.$emit('chooseCancel')
    },
    ok () {
      if (this.val.id === '0') {
        this.$notify({
          title: '警告',
          message: '必须选择人员',
          type: 'warning'
        })
      } else {
        this.$emit('chooseOk', this.val)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/choose_user/index.vue